import { useSearchParams } from 'react-router-dom';

export type TParams = {
  authId: string;
  assetId: string;
  leadId: string;
  source: string;
};

export const useQueryParams = <T extends Record<string, string>>(keys: (keyof T)[]): T => {
  const [searchParams] = useSearchParams();

  return keys.reduce((acc, key) => {
    acc[key] = (searchParams.get(key as string) ?? '') as T[keyof T];
    return acc;
  }, {} as T);
};
